//@ts-check
import { open, close, register } from './actions';
import { TYPES } from './variants';
var API = {
  open: open,
  close: close,
  register: register,
  TYPES: TYPES
};
export default API;